export const PAYOUT_LIST = "payout-list";
export const CLEAR_PAYOUT_DATA = "clear-payout-data";
export const CALCULATE_CUMULATIVE_DATA = "calculate-cumulative-data";
export const PAYTM_ASSURED_CLAIM_REPORT = "paytm-assured-claim-report";
export const CLEAR_PAYTM_ASSURED_CLAIM_REPORT =
  "clear-paytm-assured-claim-report";
